// extracted by mini-css-extract-plugin
export default {"nameYourPriceSubtitle":"DhJcsi","minPriceTip":"ATqpuf"};